/**
 * @ Author: Zhang Yujun
 * @ Create Time: 2025-02-13 10:05:35
 * @ Modified by: Zhang Yujun
 * @ Modified time: 2025-02-14 11:47:54
 * @ Description:
 */

import axios from '../axios'
import store from '@/store'
import CONFIG from '@/config'
import { getStorage, getUserId, getJSESSIONID } from '@/utils'

// 访问日志默认参数
const defaultAccessData = {
  appCode: CONFIG.APP_CODE,
  role: 'guest',
  cachable: true,
  entry: 'portal',
  areaCode: '',
  platform: 'ott',
  apkVersion: '',
  jsonData: '{}',
  accessType: 'column',
  sourceCode: 'portal',
  sourceType: 'column',

  note: getJSESSIONID()
}

let getAreaCode = false
if (!getAreaCode) {
  getCurrentCityInfo().then(res => {
    if (res.code === 0) {
      defaultAccessData.areaCode = res.data.code
      getAreaCode = true
    }
  })
}

/**
 * 获取用户所在城市信息
 * @param {object} obj
 * @returns
 */
function getCurrentCityInfo () {
  if (axios.defaults.headers.common.Authorization) {
    return axios.post('isg/util/get-cityInfo')
  } else {
    return new Promise(resolve => {
      setTimeout(resolve, 1000)
    }).then(() => {
      return getCurrentCityInfo()
    })
  }
}

/**
 * 添加登录日志
 * @param {object} data 日志参数
 * @returns {Promise<{code:number,data:string,text:string}>}
 */
export function addLoginLog (payload) {
  if (!getAreaCode) {
    return new Promise(resolve => {
      setTimeout(resolve, 1000)
    }).then(() => {
      addLoginLog(payload)
    })
  }
  return axios.post('isg/log/login', {
    orderType: store.state.user.vipExpiredDate ? 'month' : 'free',
    ...defaultAccessData,
    userId: getUserId() || 'unknown',
    ...payload
  })
}
/**
 * 添加访问日志
 * @param {object} data 日志参数
 * @returns {Promise<{code:number,data:string,text:string}>}
 */
export function addAccessLog (payload) {
  if (!getAreaCode || (store.state.user.userId && !store.state.user.getVip)) {
    return new Promise(resolve => {
      setTimeout(resolve, 1000)
    }).then(() => {
      addAccessLog(payload)
    })
  }
  return axios.post('isg/log/access', {
    orderType: store.state.user.vipExpiredDate ? 'month' : 'free',
    ...defaultAccessData,
    userId: getUserId() || 'unknown',
    ...payload
  })
}
/**
 * 记录点播日志
 * @param {object} payload
 * @returns
 */
export function addVodLog (payload) {
  if (!getAreaCode || (store.state.user.userId && !store.state.user.getVip)) {
    return new Promise(resolve => {
      setTimeout(resolve, 1000)
    }).then(() => {
      addVodLog(payload)
    })
  }
  const data = getStorage()
  return axios.post('isg/log/vod', {
    orderType: data.orderType ? 'month' : 'free',
    ...defaultAccessData,
    userId: getUserId() || 'unknown',
    metadataType: 'smallvod',
    ...payload
  })
}
/**
 * 更新点播日志
 * @param {object} payload
 * @returns
 */
export function updateLastVodLog (payload) {
  if (!getAreaCode) {
    return new Promise(resolve => {
      setTimeout(resolve, 1000)
    }).then(() => {
      updateLastVodLog(payload)
    })
  }
  return axios.post('isg/log/vod/update-last', {
    appCode: CONFIG.APP_CODE,
    userId: getUserId() || 'unknown',
    ...payload
  })
}
